import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import { newsroomContent } from '@/app/[locale]/newsroom/_data/newsroomContent';
import { Section } from '@/app/components/LegacyLandingPage/components';

import { NewsroomAccordionContent } from './NewsroomAccordionContent';
import { NewsroomContactUs } from './NewsroomContactUs';
import { NewsroomAccordionHeader } from './NewsroomAccordionHeader';
import type { MessageKey } from 'types/LocaleMessageKey';
import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';
import { useConfig } from 'statsig-react';

export interface NewsroomContentObj {
  date?: MessageKey;
  headline?: MessageKey;
  subcopy?: MessageKey;
  url?: string;
}

export const NewsroomBodySection = () => {
  const t = useTranslations();
  const isGen4Enabled = useOuraGen4Enabled();

  const articles = [...newsroomContent];
  const { config } = useConfig('or4_newsroom_launch_url');

  if (isGen4Enabled) {
    articles.unshift({
      date: 'press_or4_release_date',
      headline: 'press_or4_release_title',
      subcopy: 'press_or4_release_subcopy',
      url: (config.value['url'] as string) || '/',
    });
  }

  return (
    <Section
      className="relative -mt-8 rounded-3xl border-t bg-sandstone-100 pt-16"
      data-cy="newsroom-body-section"
    >
      <NewsroomContactUs />
      <LayoutGrid>
        <TypographyV3
          className="col-main lg:col-end-8"
          variant="h4"
          Element="h2"
        >
          {t('press_list_title')}
        </TypographyV3>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main', lg: 9 }}>
          <Accordion openAtIndex={1}>
            {articles.flatMap((item, index) => [
              <AccordionHeader key={`header-${index}`}>
                <NewsroomAccordionHeader
                  date={item.date}
                  headline={item.headline}
                />
              </AccordionHeader>,
              <AccordionContent key={`content-${index}`}>
                <NewsroomAccordionContent
                  subcopy={item.subcopy}
                  url={item.url}
                />
              </AccordionContent>,
            ])}
          </Accordion>
        </GridItem>
      </LayoutGrid>
    </Section>
  );
};
